import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Lang = "pl" | "en";

export default function PremiumLanguageSelector() {
  const { i18n } = useTranslation();
  const { t } = useAppTranslation("common");

  const currentLang: Lang = i18n.language?.startsWith("pl")
    ? "pl"
    : "en";

  const handleChange = async (event: any) => {
    const newLang = event.target.value as Lang;
    await i18n.changeLanguage(newLang);
    localStorage.setItem("appLanguage", newLang);
  };

  return (
    <Box>
      <Typography
        variant="caption"
        sx={{
          color: "rgba(229, 237, 242, 0.6)",
          textTransform: "uppercase",
          letterSpacing: 0.8,
          fontWeight: 600,
        }}
      >
        {t("Language")}
      </Typography>

      <Select
        value={currentLang}
        onChange={handleChange}
        size="small"
        variant="standard"
        disableUnderline
        sx={{
          mt: 0.5,
          width: "100%",
          color: "#E5EDF2",
          fontWeight: 500,

          "& .MuiSelect-icon": {
            color: "rgba(229, 237, 242, 0.7)",
          },

          "& .MuiSelect-select": {
            paddingLeft: 0,
            paddingRight: 3,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: 2,
            },
          },
        }}
      >
        <MenuItem value="pl">Polski</MenuItem>
        <MenuItem value="en">English</MenuItem>
      </Select>
    </Box>
  );
}